import React from 'react';
import { urls } from 'app-constants';
import ObjectTypeFilter from './ObjectTypeFilter';


const ReleaseTypeFilter = props => <ObjectTypeFilter dataUrl={urls.releaseTypes} {...props} />;

export default ReleaseTypeFilter;
